import React, { useEffect, useRef, useState } from 'react';
import Typed from 'typed.js';
import './Hero.css';

const Hero = () => {
  const typedRef = useRef(null);
  const [typingComplete, setTypingComplete] = useState(false);

  useEffect(() => {
    const typed = new Typed(typedRef.current, {
      strings: ['./v8'],
      typeSpeed: 100,
      showCursor: true,
      cursorChar: '█',
      onComplete: () => {
        setTypingComplete(true);
      },
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <section className="hero" id="hero" data-testid="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">
          <span ref={typedRef} data-testid="typed-text"></span>
        </h1>
        <p className={`hero-tagline ${typingComplete ? 'show' : ''}`} data-testid="hero-tagline">
          learner. builder. operator.
        </p>
      </div>
    </section>
  );
};

export default Hero;
